import styled from 'styled-components'

export const NavTabContainer = styled.div`
    height: 36px;
`
